"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.slice.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _typeValidation = _interopRequireDefault(require("./typeValidation"));
var _inputTextfield = require("@citrus/input-textfield");
var _inputCheckbox = require("@citrus/input-checkbox");
var _findIndexes = _interopRequireDefault(require("@pcty/utils-commonjs/array/findIndexes"));
var _removeAt = _interopRequireDefault(require("@pcty/utils-commonjs/array/removeAt"));
var _isNotNullOrEmpty = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNotNullOrEmpty"));
var _isNull = _interopRequireDefault(require("@pcty/utils-commonjs/value/isNull"));
var _lodash = _interopRequireDefault(require("lodash.isequal"));
var _PctyQuestion = require("./PctyQuestion.Common");
require("./index.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PctyQuestionCheckbox = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PctyQuestionCheckbox, _Component);
  var _super = _createSuper(PctyQuestionCheckbox);
  function PctyQuestionCheckbox(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PctyQuestionCheckbox);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getListItems", function () {
      var _this$props = _this.props,
        id = _this$props.id,
        otherQuestion = _this$props.otherQuestion,
        disabled = _this$props.disabled;
      var retOptions = _this.state.sortedOptions.map(function (x, index) {
        return /*#__PURE__*/_react.default.createElement(_inputCheckbox.Checkbox, {
          automationId: "question-".concat(_this.props.number, "-Checkbox-").concat(index),
          id: "".concat(id, "-checkbox-item-").concat(index),
          key: "".concat(id, "-checkbox-item-").concat(index),
          value: x.id
        }, x.value);
      });
      if (otherQuestion && otherQuestion.label && otherQuestion.enabled) {
        var otherQuestionListItem = /*#__PURE__*/_react.default.createElement(_inputCheckbox.Checkbox, {
          id: "".concat(id, "-checkbox-item-").concat(_this.state.sortedOptions.length),
          key: "".concat(id, "-checkbox-item-").concat(_this.state.sortedOptions.length),
          automationId: "question-".concat(_this.props.number, "-other-option"),
          value: "otherOption"
        }, _this.props.otherQuestion ? _this.props.otherQuestion.label : 'Other', _this.state.showOtherTextbox && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _this.props.readOnly ? /*#__PURE__*/_react.default.createElement("div", {
          className: "pcty-border-all pcty-readonly-otherfield"
        }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
          className: "pcty-question-builder-option-no-answer",
          id: "".concat(_this.props.id, "-othertext-").concat(_this.props.id.toString()),
          maxLength: 500,
          disabled: _this.props.disabled,
          readOnly: true,
          placeholder: _this.props.otherQuestion.placeholder || 'Enter text',
          onChange: _this.setOtherValue,
          value: _this.state.otherOptionText,
          automationId: "question-".concat(_this.props.number, "-Checkbox-other-text"),
          wrapperStyles: {
            display: 'inline'
          }
        })) : /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
          className: "pcty-question-builder-option-no-answer",
          id: "".concat(_this.props.id, "-othertext-").concat(_this.props.id.toString()),
          key: "".concat(_this.props.id, "-othertext-").concat(_this.props.id.toString()),
          maxLength: 500,
          disabled: _this.props.disabled,
          placeholder: _this.props.otherQuestion.placeholder || 'Enter text',
          onChange: _this.setOtherValue,
          value: _this.state.otherOptionText,
          automationId: "question-".concat(_this.props.number, "-Checkbox-other-text"),
          wrapperStyles: {
            display: 'inline'
          }
        })));
        retOptions.push(otherQuestionListItem);
      }
      return retOptions;
    });
    var selectedIndexes = [];
    var otherOptionText = _this.props.otherQuestion ? _this.props.otherQuestion.value : '';
    var showOtherTextbox = false;
    var sortedOptions = (0, _PctyQuestion.getSortedOptions)({
      array: _this.props.options,
      sortOrder: _this.props.sortOrder
    });
    if ((0, _isNotNullOrEmpty.default)(props.response)) {
      var optionIds = props.response.map(function (x) {
        return x.optionId;
      });
      selectedIndexes = (0, _findIndexes.default)(sortedOptions, function (x) {
        return optionIds.indexOf(x.id) >= 0;
      });
      var responseOtherIndex = _this.props.response.findIndex(function (x) {
        return x.optionId === 'otherOption';
      });
      if (responseOtherIndex >= 0) {
        otherOptionText = props.response[responseOtherIndex].value;
        selectedIndexes.push(sortedOptions.length);
        showOtherTextbox = true;
      }
    }
    _this.state = {
      selectedIndexes: selectedIndexes,
      otherOptionText: otherOptionText,
      sortedOptions: sortedOptions,
      showOtherTextbox: showOtherTextbox
    };
    _this.setOtherValue = _this.setOtherValue.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(PctyQuestionCheckbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _isNull.default)(this.props.response)) {
        this.props.onResponse(this.props.id, []);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var newState = {};
      if (!(0, _lodash.default)(this.props.options, nextProps.options)) {
        newState.sortedOptions = (0, _PctyQuestion.getSortedOptions)({
          array: this.props.options,
          sortOrder: this.props.sortOrder
        });
      }
      if ((0, _isNotNullOrEmpty.default)(nextProps)) {
        var response = nextProps.response || [];
        var optionIds = response.map(function (x) {
          return x.optionId;
        }).filter(function (x) {
          return x !== undefined;
        });
        var responseOtherIndex = response.findIndex(function (x) {
          return x.optionId === 'otherOption';
        });
        newState.showOtherTextbox = false; // new default state
        newState.selectedIndexes = (0, _findIndexes.default)(this.state.sortedOptions, function (x) {
          return optionIds.indexOf(x.id) >= 0;
        });

        // checking the box for the otherOption
        if (responseOtherIndex >= 0 && newState.selectedIndexes.indexOf(this.state.sortedOptions.length) < 0) {
          newState.selectedIndexes.push(this.state.sortedOptions.length);
          newState.showOtherTextbox = true;
        } else if (responseOtherIndex < 0 && newState.selectedIndexes.indexOf(this.state.sortedOptions.length) >= 0) {
          newState.selectedIndexes = newState.selectedIndexes.slice(0, newState.selectedIndexes.length);
          newState.showOtherTextbox = false;
        }
      }
      this.setState(_objectSpread({}, newState));
    }
  }, {
    key: "setOtherValue",
    value: function setOtherValue(_ref) {
      var textId = _ref.textId,
        value = _ref.value;
      this.setState({
        otherOptionText: value
      });
      var index = this.state.sortedOptions.length;
      this.onResponseHandler(textId, index, value, this.props.response, this.props.onResponse);
    }
  }, {
    key: "onResponseHandler",
    value: function onResponseHandler(id, index, value, response, onResponse) {
      if (this.props.readOnly) return;
      response = response || [];
      var option = this.state.sortedOptions[index];
      var optionId = index >= this.state.sortedOptions.length && !option ? 'otherOption' : option.id;
      var responseIndex = (0, _isNotNullOrEmpty.default)(response) ? response.findIndex(function (x) {
        return x.optionId === optionId;
      }) : -1;
      var parentId = this.props.id;
      if (responseIndex >= 0 && !value) {
        onResponse(parentId, (0, _removeAt.default)(response, responseIndex));
      } else if (optionId === 'otherOption') {
        var otherText = typeof value === 'string' ? value : this.state.otherOptionText;
        var otherIndex = (0, _isNotNullOrEmpty.default)(response) ? response.findIndex(function (x) {
          return x.optionId === optionId;
        }) : index;
        response = (0, _removeAt.default)(response, otherIndex);
        onResponse(parentId, [].concat((0, _toConsumableArray2.default)(response), [{
          optionId: optionId,
          value: otherText
        }]));
      } else {
        onResponse(parentId, [].concat((0, _toConsumableArray2.default)(response), [{
          optionId: optionId
        }]));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestion.renderHint)(this.props.id, this.props.hint), (0, _PctyQuestion.renderScenario)(this.props.id, this.props.scenario), (0, _PctyQuestion.renderQuestion)(this.props.id, this.props.number, this.props.question, this.props.required, this.props.readOnly), /*#__PURE__*/_react.default.createElement(_inputCheckbox.CheckboxList, {
        className: this.state.showOtherTextbox ? 'pcty-question-checklist-with-other' : 'pcty-question-checklist',
        columns: this.props.columns,
        id: this.props.id,
        key: this.props.id,
        disabled: this.props.disabled,
        onChange: function onChange(_ref2) {
          var id = _ref2.id,
            index = _ref2.index,
            value = _ref2.value;
          return _this2.onResponseHandler(id, index, value, _this2.props.response, _this2.props.onResponse);
        },
        automationId: "question-".concat(this.props.number, "-Checkbox"),
        selectedIndexes: this.state.selectedIndexes
      }, this.getListItems()));
    }
  }]);
  return PctyQuestionCheckbox;
}(_react.Component);
PctyQuestionCheckbox.propTypes = {
  /** The number of columns in which to display the options for the component. */
  columns: _propTypes.default.number,
  /** A hint that you want to give the person answering the question. */
  hint: _propTypes.default.string,
  /** The id for the component. */
  id: _propTypes.default.string.isRequired,
  /** Whether or not the question will be disabled. */
  disabled: _propTypes.default.bool,
  /** Whether or not the question will be readOnly. */
  readOnly: _propTypes.default.bool,
  /** The question number. */
  number: _propTypes.default.number.isRequired,
  /** Whether or not the question will be displayed as required. */
  required: _propTypes.default.bool,
  /** Callback function that receives response information each time someone interacts with the question. */
  onResponse: _propTypes.default.func.isRequired,
  /** The array of option objects. */
  options: _propTypes.default.array.isRequired,
  /** The object that configures the Other field. */
  otherQuestion: _propTypes.default.shape({
    value: _propTypes.default.string,
    label: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    enabled: _propTypes.default.bool
  }),
  /** The question text. */
  question: _propTypes.default.string.isRequired,
  /** An array of response objects that are output from the component. */
  response: _propTypes.default.array,
  /** Some text that sets up your question. */
  scenario: _propTypes.default.string,
  /** The sortOrder of the options of the component. */
  sortOrder: _propTypes.default.oneOf(['defined', 'ascending', 'descending', 'random']),
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyQuestionCheckbox');
  }
};
PctyQuestionCheckbox.defaultProps = {
  columns: 1,
  scenario: null,
  sortOrder: 'defined',
  disabled: false,
  readOnly: false,
  __TYPE: 'PctyQuestionCheckbox'
};
var _default = exports.default = PctyQuestionCheckbox;